import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPound: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pound, currency, money, coin, GBP"><path d="M14.5 7.50108C14.0061 7.03638 13.3306 6.75 12.5856 6.75C11.0725 6.75 9.8459 7.93147 9.8459 9.38889C9.8459 10.8463 11 12 11 12L10.9889 12.0278M14.2295 16.25H9.29795L10.9889 12.0278M10.9889 12.0278H8.75M10.9889 12.0278H14.2295M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPound;
